/* maximize.icon.svg.js */

"use strict";
module.exports = {
    icon: `    
            <svg viewBox="0 0 16 16" preserveAspectRatio="none">
            <polygon class="foreground-gl" points="16,7.5 8.5,7.5 8.5,0 7.5,0 7.5,7.5 0,7.5 0,8.5 7.5,8.5 7.5,16 8.5,16 8.5,8.5 16,8.5 "/>
            </svg>
         `,
};
